import { observer } from 'mobx-react-lite';

import { Select } from '@components/select';
import { useStore } from 'models/Provider';

function TemplateSelector({ onChange, templates }) {
  const { t } = useStore();
  const items = templates.map((t) => ({
    value: t.id,
    label: t.title || t.name,
  }));
  return (
    <Select
      label={t('rejectform.label.templateselect')}
      isClearable={false}
      placeholder={t('rejectform.template.drop.title')}
      options={items}
      onChange={onChange}
    />
  );
}

export default observer(TemplateSelector);
